import { useAppSelector } from 'app/hooks';
import { ProvisionTimingProps } from 'models';
import { selectTimingInfo } from 'store/slices/mainSlice';
import { attrLang } from 'utils';
import TimingItem from '../TimingItem';

interface TimingGroupProps {
  dishCode: string;
  orderIdx: number;
  provisionTiming?: ProvisionTimingProps;
}

const TimingGroup = ({ provisionTiming, dishCode, orderIdx }: TimingGroupProps) => {
  const timingInfo = useAppSelector(selectTimingInfo);

  if (!provisionTiming || provisionTiming.timing_flg === '0') return null;

  const timingInfoId = provisionTiming.timing_info_id;
  const timingDetail = timingInfo[timingInfoId];

  const servingPattern = timingDetail?.serving_pattern;

  const timingTitle = attrLang(timingDetail, 'title');

  const groupMainTiming = servingPattern.map((pattern) => {
    const timingCode = Object.keys(pattern)[0];
    const timingItem = pattern[timingCode];
    const timingName = attrLang(timingItem, 'msg');

    return (
      <TimingItem
        key={timingCode}
        dishCode={dishCode}
        timingCode={timingCode}
        timingName={timingName}
        provisionTiming={provisionTiming}
        orderIdx={orderIdx}
      />
    );
  });

  return (
    <div id={`option-group-${dishCode}-${orderIdx}-timing`} className="menu-option-group">
      <div className="option-group-header">
        <span dangerouslySetInnerHTML={{ __html: timingTitle }} />
      </div>
      <ul className="list-option-group">{groupMainTiming}</ul>
    </div>
  );
};

export default TimingGroup;
